import UpdateEmailAddressModal from './UpdateEmailAddressModal';

export default UpdateEmailAddressModal;
